import React, { FunctionComponent } from 'react';
import {Page} from 'b302-frontend-library';
import UniversitiesPage from './UniversitiesPage';

interface Props {}

const Favorites: FunctionComponent<Props> = () => {

    return (
        <Page className={'favorites-page'}>
            <UniversitiesPage title={'Favorite universities'} favorites={true} />
        </Page>
    );
};

export default Favorites;
